<template>
  <section class="mb-6">
    <nav class="columns">
      <div class="column is-4">
        <nav class="level pb-0">
          <div class="level-item has-text-centered">
            <div>
              <p class="heading">
                {{ $t('attributes.meeting_employee') }}
              </p>
              <p class="title is-size-5">
                {{
                  `(${this.meeting.employee_code}) ${this.meeting.employee_name}`
                }}
              </p>
            </div>
          </div>
          <div class="level-item has-text-centered">
            <div>
              <p class="heading">
                {{ $t('attributes.meeting_tel') }}
              </p>
              <p class="title is-size-5">
                {{ this.meeting.tel || '&nbsp;' }}
              </p>
            </div>
          </div>
          <div class="level-item has-text-centered">
            <div>
              <p class="heading">
                {{ $t('attributes.lecturer') }}
              </p>
              <p class="title is-size-5">
                {{ this.meeting.lecturer || '&nbsp;' }}
              </p>
            </div>
          </div>
          <div class="level-item has-text-centered">
            <div>
              <p class="heading">
                {{ $t('attributes.assistant') }}
              </p>
              <p class="title is-size-5">
                {{ this.meeting.assistant || '&nbsp;' }}
              </p>
            </div>
          </div>
          <div class="level-item has-text-centered">
            <div>
              <p class="heading">
                {{ $t('attributes.meal_provided') }}
              </p>
              <p class="title is-size-5">
                {{ whetherStatus(this.meeting.meal_provided) }}
              </p>
            </div>
          </div>
        </nav>
      </div>
      <div class="column is-5">
        <nav class="level pb-0">
          <div class="level-left">
            <div class="level-item">
              <div>
                <p class="heading">
                  {{ $t('attributes.meeting_desc') }}
                </p>
                <p class="title is-size-5">
                  {{ this.meeting.description || '&nbsp;' }}
                </p>
              </div>
            </div>
          </div>
        </nav>
      </div>
      <div class="column is-3">
        <div class="buttons is-right">
          <b-button
            v-if="canModify()"
            type="is-primary"
            style="width: 80px;"
            @click.prevent.stop="onAddApplies"
            :disabled="isExpired()"
          >
            <span class="icon">
              <i class="mdi mdi-plus" />
            </span>
            {{ $t('attributes.add') }}
          </b-button>
          <b-button
            v-if="canModify()"
            :loading="sending"
            class="is-warning"
            @click="onSend"
            :disabled="isExpired()"
          >
            {{ $t('attributes.update') }}
          </b-button>
          <b-button
            v-if="canModify()"
            :loading="sending"
            class="is-success"
            @click="onExport"
          >
            {{ $t('message.export') }}
          </b-button>
        </div>
      </div>
    </nav>

    <section v-if="canModify() && !isExpired()" class="mt-4">
      <form-wrapper :validator="$v.form">
        <b-table
          :data="applies"
          :loading="loadingApplicants"
          hoverable
          narrowed
          scrollable
        >
          <b-table-column
            field="id"
            :visible="false"
            :label="$t('attributes.id')"
            width="400"
            v-slot="props"
          >
            {{ props.row.id }}
          </b-table-column>
          <b-table-column label="順位" width="80" centered v-slot="props">
            <b-tag
              :type="
                props.row.index > meeting.capacity ? 'is-warning' : 'is-primary'
              "
              size="is-medium"
            >
              {{ props.row.index.toString().padStart(3, '0') }}
            </b-tag>
          </b-table-column>
          <b-table-column
            field="employee_code"
            :label="$t('attributes.meeting_sales')"
            width="160"
            v-slot="props"
          >
            <p class="nowrap">
              ({{ props.row.employee_code }}) {{ props.row.employee_name }}
            </p>
          </b-table-column>
          <b-table-column
            field="tel"
            :label="$t('attributes.fullname')"
            width="160"
            v-slot="props"
          >
            <b-input
              :ref="`name-input-${props.index}`"
              v-model="props.row.name"
              name="name"
              maxlength="20"
              :has-counter="false"
              :placeholder="
                $t('message.please_input_', [$t('attributes.fullname')]) +
                  $t('message.word_limit', [20])
              "
            ></b-input>
          </b-table-column>
          <b-table-column
            field="tel"
            :label="$t('attributes.meeting_tel')"
            width="160"
            v-slot="props"
          >
            <b-input
              :ref="`tel-input-${props.index}`"
              v-model="props.row.tel"
              name="tel"
              maxlength="20"
              :has-counter="false"
              :placeholder="
                $t('message.please_input_', [$t('attributes.meeting_tel')]) +
                  $t('message.word_limit', [20])
              "
            ></b-input>
          </b-table-column>
          <b-table-column
            field="remark"
            :label="$t('attributes.remark')"
            v-slot="props"
          >
            <b-input
              :ref="`remark-input-${props.index}`"
              v-model="props.row.remark"
              name="remark"
              maxlength="500"
              :has-counter="false"
              :placeholder="
                $t('message.please_input_', [$t('attributes.remark')])
              "
            ></b-input>
          </b-table-column>
          <b-table-column
            field="created_at"
            :label="$t('attributes.meeting_apply_at')"
            width="180"
            v-slot="props"
          >
            {{ formatDateTime(props.row.created_at) }}
          </b-table-column>
          <b-table-column
            :label="$t('attributes.function')"
            width="60"
            centered
            v-slot="props"
          >
            <b-button
              type="is-danger"
              class="is-fullwidth"
              @click.prevent.stop="onDeleteApply(props.row)"
            >
              <span class="icon">
                <i class="mdi mdi-delete" />
              </span>
            </b-button>
          </b-table-column>

          <template #empty>
            <section class="section">
              <div class="content has-text-grey has-text-centered">
                <p>
                  <b-icon icon="emoticon-sad" size="is-large" />
                </p>
              </div>
            </section>
          </template>
        </b-table>
      </form-wrapper>

      <div v-if="canModify()" class="mt-2 buttons is-right">
        <b-button
          v-if="canModify()"
          type="is-primary"
          style="width: 80px;"
          @click.prevent.stop="onAddApplies"
          :disabled="isExpired()"
        >
          <span class="icon">
            <i class="mdi mdi-plus" />
          </span>
          {{ $t('attributes.add') }}
        </b-button>
        <b-button
          v-if="canModify()"
          :loading="sending"
          class="is-warning"
          @click="onSend"
          :disabled="isExpired()"
        >
          {{ $t('attributes.update') }}
        </b-button>
        <b-button
          v-if="canModify()"
          :loading="sending"
          class="is-success"
          @click="onExport"
        >
          {{ $t('message.export') }}
        </b-button>
      </div>
    </section>

    <section v-else class="mt-4">
      <b-table
        :data="applicants"
        :loading="loadingApplicants"
        hoverable
        narrowed
        scrollable
      >
        <b-table-column
          field="id"
          :visible="false"
          :label="$t('attributes.id')"
          width="400"
          v-slot="props"
        >
          {{ props.row.id }}
        </b-table-column>
        <b-table-column label="順位" width="80" centered v-slot="props">
          <b-tag
            :type="
              props.row.index >= meeting.capacity ? 'is-warning' : 'is-primary'
            "
            size="is-medium"
          >
            {{ props.row.index.toString().padStart(3, '0') }}
          </b-tag>
        </b-table-column>
        <b-table-column
          field="employee_code"
          :label="$t('attributes.meeting_sales')"
          width="160"
          v-slot="props"
        >
          <p class="nowrap">
            ({{ props.row.employee_code }}) {{ props.row.employee_name }}
          </p>
        </b-table-column>
        <b-table-column
          field="tel"
          :label="$t('attributes.fullname')"
          width="160"
          v-slot="props"
        >
          {{ props.row.name }}
        </b-table-column>
        <b-table-column
          field="tel"
          :label="$t('attributes.meeting_tel')"
          width="160"
          v-slot="props"
        >
          {{ props.row.tel }}
        </b-table-column>
        <b-table-column
          field="remark"
          :label="$t('attributes.remark')"
          v-slot="props"
        >
          {{ props.row.remark }}
        </b-table-column>
        <b-table-column
          field="created_at"
          :label="$t('attributes.meeting_apply_at')"
          width="180"
          v-slot="props"
        >
          {{ formatDateTime(props.row.created_at) }}
        </b-table-column>

        <template #empty>
          <section class="section">
            <div class="content has-text-grey has-text-centered">
              <p>
                <b-icon icon="emoticon-sad" size="is-large" />
              </p>
            </div>
          </section>
        </template>
      </b-table>
    </section>

    <b-loading
      :active="loadingApplicants || sending"
      :is-full-page="true"
      :can-cancel="false"
    />
  </section>
</template>

<script>
import Vue from 'vue'
import { MEETING_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'
import { maxLength, required, requiredIf } from 'vuelidate/lib/validators'
import { MEETING_TYPE } from '@/utils/constants'

export default {
  name: 'Meeting',

  props: {
    meeting: {
      type: Object,
      required: true
    },
    sending: {
      type: Boolean
    }
  },
  watch: {
    meeting(item) {
      this.loadApplicants(item)
    }
  },
  data() {
    return {
      loadingApplicants: false,

      originApplicants: [],
      applicants: [],

      form: {
        applicants: []
      }
    }
  },
  computed: {
    applies() {
      return this.applicants.filter(a => a.status !== 'delete')
    }
  },
  validations() {
    return {
      form: {
        applicants: {
          required,
          $each: {
            name: {
              requiredIf: requiredIf(function(model) {
                return model.status !== 'delete'
              }),
              maxLength: maxLength(20)
            },
            tel: { maxLength: maxLength(20) },
            remark: { maxLength: maxLength(200) }
          }
        }
      }
    }
  },
  mounted() {
    this.loadApplicants(this.meeting)
  },
  methods: {
    async loadApplicants(meeting) {
      try {
        const api = `${MEETING_API}/${meeting.id}/applicants`
        this.loadingApplicants = true
        const res = await this.axios.get(api)
        this.originApplicants = res.data.data
        this.applicants = res.data.data.map((apply, index) => ({
          id: apply.id,
          index: index + 1,
          status: 'update',
          employee: `(${apply.employee_code}) ${apply.employee_name}`,
          employee_code: apply.employee_code,
          employee_name: apply.employee_name,
          name: apply.name,
          tel: apply.tel,
          remark: apply.remark,
          created_at: apply.created_at
        }))
      } catch (e) {
        this.originApplicants = []
        this.applicants = []

        notifyService.fetch_error('meeting_applicants', e)
      } finally {
        this.loadingApplicants = false
      }
    },

    isExpired() {
      return this.meeting.is_expired
    },
    canModify() {
      const user = Vue.$auth.user()

      if (user.is_admin) {
        return true
      }

      if (this.meeting.employee_code === user.emp_code) {
        return true
      }

      return user.area_code_perm.includes(this.meeting.area_code)
    },

    onAddApplies() {
      this.$buefy.dialog.prompt({
        message: `增加申請人數？`,
        inputAttrs: {
          type: 'number',
          placeholder: '輸入人數',
          value: 1,
          min: 1,
          max: 100
        },
        trapFocus: true,
        onConfirm: value => {
          for (let i = 0; i < value; i++) {
            this.addNewApply(this.applicants)
          }
        }
      })
    },
    addNewApply(applicants) {
      if (!this.canModify()) {
        return
      }

      const user = Vue.$auth.user()

      const last =
        applicants.length > 0 ? applicants[applicants.length - 1].index + 1 : 1

      applicants.push({
        id: null,
        index: last,
        status: 'create',
        employee: `(${user.emp_code}) ${user.name}`,
        employee_code: user.emp_code,
        employee_name: user.name,
        name: null,
        tel: null,
        remark: null,
        created_at: null
      })
    },
    onDeleteApply(apply) {
      if (apply.status === 'create' && !apply.name) {
        this.applicants = this.applicants
          .filter(a => a.index !== apply.index)
          .map(a => ({
            ...a,
            index: a.index > apply.index ? a.index - 1 : a.index
          }))
      } else {
        this.$buefy.dialog.confirm({
          message: this.$t('attributes.confirm_delete'),
          onConfirm: () => {
            this.deleteApply(apply)
          }
        })
      }
    },
    deleteApply(apply) {
      if (apply.status === 'create') {
        this.applicants = this.applicants
          .filter(a => a.index !== apply.index)
          .map(a => ({
            ...a,
            index: a.index > apply.index ? a.index - 1 : a.index
          }))
      } else {
        apply.status = 'delete'
      }
    },
    async onSend() {
      this.form.applicants = [...this.applicants]

      this.$v.$touch()
      if (this.$v.$invalid) {
        notifyService.error('請確實填寫每位旅客姓名')
        return
      }

      this.$emit('onSend', this.meeting, this.form.applicants)
    },

    async onExport() {
      const api = `${MEETING_API}/${this.meeting.id}/export`

      const config = {
        headers: { Accept: 'application/vnd.ms-excel' },
        responseType: 'blob'
      }

      try {
        this.sending = true
        const response = await this.axios.post(api, {}, config)

        const type =
          this.meeting.type === MEETING_TYPE.BRIEFING ? '說明會' : '上順教室'
        const date = this.$dayjs().format('YYYYMMDDHHmmss')
        const fileName = `${this.meeting.title}_${type}_${date}`

        const blob = new Blob([response.data], { type: response.data.type })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      } catch (e) {
        notifyService.error('下載失敗', e)
      } finally {
        this.sending = false
      }
    }
  }
}
</script>

<style scoped></style>
